import React from "react";
import classNames from "classnames";

import { Chevron } from "src/app/components/Chevron/Chevron";
import SelectedFiltersCounter from "../audiences-manager/AudiencesSearch/partials/SelectedFiltersCounter/SelectedFiltersCounter";

export default function CollapsibleTitle({
  title,
  isExpanded,
  setExpanded,
  metricsCount,
  className,
}) {
  return (
    <div
      onClick={() => setExpanded((prev) => !prev)}
      className={classNames("audience-search__title clickable", className, {
        "audience-search__title--no-border": !isExpanded,
      })}
    >
      <div className="audience-search__title__text">
        {title}
        <SelectedFiltersCounter amount={metricsCount} />
      </div>
      <Chevron
        expanded={isExpanded}
        setExpanded={setExpanded}
        variant="white"
      />
    </div>
  );
}
